<template>
  <ClientOnly>
    <div>
      <DevicePerformanceCheck />
      <MSEWrapperPart
        :vacancy="vacancy"
        :video-url="videoUrl"
        :interviewer-url="interviewerUrl"
        :start-time="startTime"
        :stop-time="stopTime"
        :listening-start-time="listeningStartTime"
        :listening-stop-time="listeningStopTime"
        autoplay
      />
    </div>
  </ClientOnly>
</template>

<script>
import ClientOnly from 'vue-client-only';
import MSEWrapperPart from '@huntica/huntica-interview-module/src/components/MSEWrapperPart.vue';
import DevicePerformanceCheck from '@huntica/huntica-interview-module/src/components/DevicePerformanceCheck.vue';
import { mapState } from 'vuex';
import { isIOS } from '@/functions';
import { interviewVideoTimestampTypes } from '../../enums';

export default {
  name: 'InterviewHelloPlayer',
  components: {
    ClientOnly,
    MSEWrapperPart,
    DevicePerformanceCheck,
  },
  props: {
    interviewer: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoUrl: 'hello.m4s',
      interviewerUrl: this.interviewer.videoUrl,
      enable: false,
    };
  },
  computed: {
    ...mapState('vacancy', ['vacancy']),
    listeningStopTime() {
      return isIOS() ? this.listeningPart.stopTime
        : this.helloPart.stopTime + this.listeningPart.stopTime - this.listeningPart.startTime;
    },
    listeningStartTime() {
      return isIOS() ? this.listeningPart.startTime : this.helloPart.stopTime;
    },
    stopTime() {
      return isIOS() ? this.helloPart.stopTime : this.helloPart.stopTime - this.helloPart.startTime;
    },
    startTime() {
      return isIOS() ? this.helloPart.startTime : 0;
    },
    helloPart() {
      return this.interviewer.videoTimestamps
        .find(t => t.type === interviewVideoTimestampTypes.HELLO);
    },
    listeningPart() {
      return this.interviewer.videoTimestamps
        .find(t => t.type === interviewVideoTimestampTypes.LISTENING);
    },
  },
};
</script>
